<div fxLayout="column" fxLayoutGap="20px">
  <app-page-header title="Configurações" variant="title-only"></app-page-header>

  <app-search-input #searchInput (search)="search($event)" placeholder=""></app-search-input>

  <div>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
        <td mat-cell *matCellDef="let row">{{ row.id }}</td>
      </ng-container>
      <ng-container matColumnDef="campus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="campus">Unidade</th>
        <td mat-cell *matCellDef="let row" [matTooltip]="row.campus">{{ row.siglaUnidade }}</td>
      </ng-container>
      <ng-container matColumnDef="chave">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="chave">Chave</th>
        <td mat-cell *matCellDef="let row">{{ row.chave }}</td>
      </ng-container>
      <ng-container matColumnDef="valor">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="valor">Valor</th>
        <td mat-cell *matCellDef="let row">{{ formataValor(row.chave, row.valor) }}</td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row; let i = index">
          <button mat-icon-button color="basic" routerLink="editar/{{ row.id }}" title="Editar">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="5">
          <app-table-no-data [searchValue]="searchInput.value"></app-table-no-data>
        </td>
      </tr>
    </table>
    <app-default-paginator #paginator></app-default-paginator>
  </div>
</div>
